import { Columns } from '@zmedia/bm-soccer-ui/components';
import React, { memo } from 'react';
import { TopPlayerSidebar } from '@zmedia/bm-soccer-ui/layout/sidebar/right';
import { TeamHeader } from '../header';
import { Content404 } from '@zmedia/bm-soccer-ui/modules/shared/components/404';

interface IProps {
    className?: string;
    children: React.ReactNode;
    error?: number;
}

export function PageTeamWrap(props: IProps) {
    const { error, children } = props;

    if (typeof error !== 'undefined' && error < 0) {
        return <Content404 error={error} />;
    }

    return (
        <>
            <Columns>
                <Columns.Column type="main">
                    <TeamHeader {...props} />
                    {children}
                </Columns.Column>
                <Columns.Column type="sub">
                    <TopPlayerSidebar {...props} />
                </Columns.Column>
            </Columns>
        </>
    );
}

export default memo(PageTeamWrap);
